function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SearchBar(_ref) {
  var _redux$webView;
  var searchValue = _ref.searchValue,
    onSearchChange = _ref.onSearchChange,
    width = _ref.width,
    navigateOnClick = _ref.navigateOnClick,
    _ref$debounceDelay = _ref.debounceDelay,
    debounceDelay = _ref$debounceDelay === void 0 ? 400 : _ref$debounceDelay,
    _ref$preventJump = _ref.preventJump,
    preventJump = _ref$preventJump === void 0 ? true : _ref$preventJump,
    _ref$enableViewportSt = _ref.enableViewportStabilizer,
    enableViewportStabilizer = _ref$enableViewportSt === void 0 ? true : _ref$enableViewportSt,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router;
  var internalWebview = redux === null || redux === void 0 || (_redux$webView = redux.webView) === null || _redux$webView === void 0 ? void 0 : _redux$webView.internalWebview;
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    push: function push() {}
  };

  // Local state to control input independently and debounce outward updates
  var _useState = useState(searchValue || ""),
    _useState2 = _slicedToArray(_useState, 2),
    localValue = _useState2[0],
    setLocalValue = _useState2[1];
  var lastEmittedRef = useRef(searchValue || "");
  var timerRef = useRef(null);

  // Keep local value in sync if parent updates searchValue externally
  useEffect(function () {
    if (searchValue !== undefined && searchValue !== lastEmittedRef.current) {
      setLocalValue(searchValue);
      lastEmittedRef.current = searchValue;
    }
  }, [searchValue]);

  // Debounce emitting changes upward
  useEffect(function () {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(function () {
      // Only emit if value actually changed
      if (onSearchChange && localValue !== lastEmittedRef.current) {
        // Emit a synthetic event matching prior signature { target: { value } }
        onSearchChange({
          target: {
            value: localValue
          }
        });
        lastEmittedRef.current = localValue;
      }
    }, debounceDelay);
    return function () {
      return timerRef.current && clearTimeout(timerRef.current);
    };
  }, [localValue, onSearchChange, debounceDelay]);
  var handleChange = function handleChange(e) {
    setLocalValue(e.target.value);
  };
  // Optional mitigation: preserve scroll position on focus inside webview to avoid jump
  var scrollPosRef = useRef({
    x: 0,
    y: 0
  });
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    setIsFocused = _useState4[1];
  var handleFocus = function handleFocus() {
    if (!preventJump || !internalWebview) return;
    setIsFocused(true);
    scrollPosRef.current = {
      x: window.scrollX,
      y: window.scrollY
    };
    // Immediate micro task restore (guards some browsers)
    requestAnimationFrame(function () {
      window.scrollTo(scrollPosRef.current.x, scrollPosRef.current.y);
    });
  };
  var handleBlur = function handleBlur() {
    setIsFocused(false);
  };

  // Use visualViewport resize events to counter keyboard-induced layout shifts
  useEffect(function () {
    if (!enableViewportStabilizer || !isFocused || !internalWebview) return;
    var vv = window.visualViewport;
    if (!vv) return;
    var restoreCount = 0;
    var handleResize = function handleResize() {
      // Limit aggressive restores
      if (restoreCount < 3) {
        window.scrollTo(scrollPosRef.current.x, scrollPosRef.current.y);
        restoreCount += 1;
      }
    };
    vv.addEventListener("resize", handleResize);
    return function () {
      return vv.removeEventListener("resize", handleResize);
    };
  }, [enableViewportStabilizer, isFocused, internalWebview]);
  return /*#__PURE__*/_jsxs("div", {
    className: "".concat(width, " flex items-center h-14 rounded-lg border border-[#dddddd] ").concat(config !== null && config !== void 0 && config.darkMode ? "bg-black !text-base-content" : "".concat(config !== null && config !== void 0 && config.setSolidBg ? config === null || config === void 0 ? void 0 : config.setSolidBg : "bg-white"), " p-2 ").concat(internalWebview ? "bg-white" : ""),
    children: [/*#__PURE__*/_jsx("input", {
      className: "peer h-full w-full outline-none text-sm text-gray-700 pr-2 placeholder:font-semibold ".concat(config !== null && config !== void 0 && config.darkMode ? "bg-black !text-base-content" : "".concat(config !== null && config !== void 0 && config.setSolidBg ? config === null || config === void 0 ? void 0 : config.setSolidBg : "bg-white")),
      type: "text",
      id: "search",
      placeholder: "Type here to search",
      value: localValue,
      onChange: handleChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      autoComplete: "off"
      // onClick={() => navigateOnClick && history.push('/dealListing')}
    }), /*#__PURE__*/_jsx("button", {
      className: "bg-primary ml-2 rounded text-white h-full px-3 z-10",
      children: "Search"
    })]
  });
}
export default SearchBar;